export function vm(){
	const headVue = new Vue({
		el: '#site-header',
		data: {
			toggle: false
        }
	});
}